import { DatePipe } from "@angular/common";
import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import * as SecureLS from "secure-ls";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Math from "exact-math";
import { StorageService } from "../../services/storage.service";
import { batchMinusYearsFromCurrentYear } from "src/app/important.config";

@Component({
  selector: "app-batch",
  templateUrl: "./batch.component.html",
  styleUrls: ["./batch.component.css"],
})
export class BatchComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");
  entryFields: boolean = false;
  createNew: boolean = true;
  alphaPattern = "[a-zA-Z .,]*";
  batchForm: FormGroup;
  page: number = 1;
  page_size: number = 10;
  submitted = false;
  manualUpdate = true;
  swal: any;
  total_count = 0;
  batcreate: any;
  batchList: any[];
  getbatch: any;
  editbatch: any;
  is_active = false;
  deletebatch: any;
  editstatus = false;
  batupdate: any;
  batstatusupdate: any;
  editid: any;
  isactiveswitch: any;
  editbut: boolean;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  batch_start: any;
  batch_end: any;
  startYear = [];
  endYear = [];
  batchStFilter: any;
  batchEnFilter: any;
  total: number;
  p: number;
  pagedItems: any[];
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private route: ActivatedRoute,
    private datepipe: DatePipe,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {}

  async ngOnInit() {
    this.batchForm = this.fb.group({
      id: [""],
      batch_start: ["", [Validators.required]],
      batch_end: ["", [Validators.required]],

      is_active: [""],
    });
    this.page = 1;

    await this.getBatch();
    await this.getPage(this.page, true);
    var datedata = new Date().getFullYear();

    //Loop and add the Year values to DropDownList.
    for (var i = datedata - batchMinusYearsFromCurrentYear; i <= 2050; i++) {
      this.startYear.push(i);
    }
    for (var i = datedata; i <= 2050; i++) {
      this.endYear.push(i);
    }
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.batchForm.reset();
    this.submitted = false;
  }
  openEdit() {
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.batchForm.reset();
    this.submitted = false;
  }

  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.batchForm.reset();
    this.createNew = true;
  }

  get forms() {
    return this.batchForm.controls;
  }
  switch(e) {
    this.isactiveswitch = e;
  }
  batchstart(e) {
    this.batch_start = e;
  }

  batchend(e) {
    this.batch_end = e;
  }
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  Filter(batchStFilter, batchEnFilter) {
    this.batchStFilter = batchStFilter;
    this.batchEnFilter = batchEnFilter;
    this.pageshow = true;
    this.page = 1;
    this.getBatch();
  }
  res() {
    this.batchStFilter = null;
    this.batchEnFilter = null;
    this.pageshow = true;
    this.page = 1;
    this.getBatch();
  }
  async createBatch(form: FormGroup) {
    let startdate = form.value.batch_start;
    let enddate = form.value.batch_end;
    this.submitted = true;

    if (this.batchForm.invalid) {
      return;
    } else if (startdate >= enddate) {
      Swal.fire(
        "Warning",
        "Batch End should be greater than Batch Start",
        "warning"
      );
      return false;
    } else {
      const inputData = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        batch_start: form.value.batch_start,
        batch_end: form.value.batch_end,
        batch: form.value.batch_start + "-" + form.value.batch_end,
        is_active: this.isactiveswitch
          ? this.isactiveswitch == true
            ? "1"
            : "0"
          : "0",
      };
      this.spinner.show();
      this.batcreate = await this.globalService.create(
        "batch/create",
        inputData
      );
      if (this.batcreate["status"] === 200) {
        Swal.fire("Success!", this.batcreate["message"], "success");
        this.spinner.show();
        this.pageshow = true;
        this.getBatch();
        this.reset();
        this.entryFields = false;
        this.createNew = true;
      }
      this.cancelFields();
      this.spinner.hide();
    }
  }

  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if(!disableCall) {
      await this.getBatch();
    }
    const res = await this.serverCall(this.batchList, page);
    this.total = this.total_count;
    this.p = page;

    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = 10;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  getBatch() {
    this.spinner.show();
    if (this.page === 1) {
      this.batchList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      role_id: this.storageService.getRole(),
      batch_start: this.batchStFilter,
      batch_end: this.batchEnFilter,
      page_size: this.page_size,
    };

    this.globalService.get("batch/list", filter).then((data) => {
      this.getbatch = data;
      this.total_count = this.getbatch["content"].count;

      if (this.getbatch["status"] === 200) {
        this.batchList = this.getbatch["content"]["rows"];

        if (this.pageshow === true) {
          this.page_count = [];
          let page_count = Math.ceil(this.total_count / this.page_size);
          if (page_count > 1) {
            this.htmlpageshow = true;
          } else {
            this.htmlpageshow = false;
          }
        }
      } else {
        this.spinner.hide();
      }
    });
    this.spinner.hide();
  }
  editBatch(id, batch) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.editbut = true;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          batch: batch,
        };

        this.editbatch = await this.globalService.get("batch/get", filter);
        let comp_details = this.editbatch["content"];

        if (this.editbatch["status"] === 200) {
          this.batchForm.controls["id"].setValue(comp_details.id);
          this.batchForm.controls["batch_start"].setValue(
            comp_details.batch_start
          );
          this.batchForm.controls["batch_end"].setValue(comp_details.batch_end);

          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
  }
  reset() {
    this.submitted = false;
    this.batchForm.reset();
    this.editstatus = false;
    this.isactiveswitch = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getBatch();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getBatch();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getBatch();
  }

  BatchStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        this.manualUpdate = value;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };
        this.batstatusupdate = await this.globalService.update(
          "batch/update/status",
          inputData
        );
        if (this.batstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.batstatusupdate["message"], "success");
          this.pageshow = true;
          this.getBatch();
        }
        if (this.batstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getBatch();
        }
      } else {
        this.pageshow = true;
        this.getBatch();
      }
    });
    this.spinner.hide();
  }
  async updateBatch(form: FormGroup) {
    let startdate = form.value.batch_start;
    let enddate = form.value.batch_end;
    this.submitted = true;

    if (this.batchForm.invalid) {
      return;
    } else if (startdate >= enddate) {
      Swal.fire(
        "Warning",
        " Batch End should be greater than Batch Start",
        "warning"
      );
      return false;
    } else {
      const inputData = {
        id: form.value.id,
        vendor_id: this.ls.get("vendor_id"),
        is_active: this.is_active ? this.is_active : this.editstatus,
        user_id: this.ls.get("createdBy"),
        batch_start: form.value.batch_start,
        batch_end: form.value.batch_end,
        batch: form.value.batch_start + "-" + form.value.batch_end,
      };
      this.spinner.show();

      this.batupdate = await this.globalService.update(
        "batch/update",
        inputData
      );

      if (this.batupdate["status"] === 200) {
        Swal.fire("Success!", this.batupdate["message"], "success");

        this.pageshow = true;
        this.getBatch();
        this.editbut = false;
        this.reset();
        this.entryFields = false;
        this.createNew = true;
      }
    }
    this.cancelFields();
    this.spinner.hide();
  }

  async deleteBatch(id, batch) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          batch: batch,
        };
        this.deletebatch = await this.globalService.delete(
          "batch/delete",
          filter
        );
        if (this.deletebatch["status"] === 200) {
          this.batchList = [];
          Swal.fire("Success!", this.deletebatch["message"], "success");
          this.pageshow = true;
          this.getBatch();
        }
      }
    });
    this.spinner.hide();
  }

  formAddReset() {
    this.batchForm.reset();
    this.editbut = false;
  }
  formUpdateReset() {
    this.batchForm.controls["id"].setValue(this.editbatch["content"].id);
    this.batchForm.controls["batch_start"].setValue(
      this.editbatch["content"].batch_start
    );
    this.batchForm.controls["batch_end"].setValue(
      this.editbatch["content"].batch_end
    );
    this.batchForm.reset();
    this.batchForm.get("id").setValue(this.editbatch["content"].id);
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getBatch();
  }
}
